import http from './http';

export const getHeaderBadgesService = async (): Promise<any> =>
  await http()
    .get(`/api/header-badges`, { noProgressBar: true })
    .then((response) => response.data);
